var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8086 0C21.6522 0 21.496 0.0601875 21.377 0.179688L20.1543 1.40039L22.5996 3.8457L23.8203 2.62305C24.0593 2.38405 24.0593 1.99777 23.8203 1.75977L22.2402 0.179688C22.1207 0.0601875 21.965 0 21.8086 0ZM19.2891 2.26562L12 9.55664V12H14.4434L21.7344 4.70898L19.2891 2.26562ZM5 3C3.895 3 3 3.895 3 5V19C3 20.105 3.895 21 5 21H19C20.105 21 21 20.105 21 19V10C21 9.448 20.552 9 20 9C19.447 9 19 9.448 19 10L18.998 19H5V7H11.7285L15.7285 3H5Z",
    fill: "#265183"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesIcon);
export default __webpack_public_path__ + "static/media/notes-icon.d0d63831a69fad0b383c9372f0e13e70.svg";
export { ForwardRef as ReactComponent };